import React, { useLayoutEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { useElementDimensions } from "@sportal/cdk/hooks";

import "./EulaBanner.scss";

interface EulaBannerProps {
  className: string;
  contentId: string;
  onHeightChange: (height: number) => void;
}

export const EulaBanner = ({
  className,
  contentId,
  onHeightChange,
}: EulaBannerProps) => {
  const container = useRef<HTMLDivElement>(null);

  const { height } = useElementDimensions(container);

  useLayoutEffect(() => {
    onHeightChange(height);
  }, [onHeightChange, height]);

  return (
    <div ref={container} className={classnames("eula-banner", className)}>
      <FormattedMessage id={contentId} />
    </div>
  );
};
